import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";
import { mediaSrc } from "@/lib/api";

export function composeTitle(specific, defaultTitle, suffix) {
  const s = (specific || "").trim();
  if (!s) return defaultTitle;
  const suf = suffix || "";
  return s.endsWith(suf.trim()) || !suf ? s : `${s}${suf}`;
}

export function truncateForMeta(text, max = 160) {
  const t = (text || "").replace(/\s+/g, " ").trim();
  return t.length <= max ? t : `${t.slice(0, max - 1)}…`;
}

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Lightweight per-page SEO — sets document.title, description and OG/Twitter
 * meta on mount. No external dependency (react-helmet not installed).
 */
export default function Seo({ title, description, path = "/", imageUrl, type = "website" }) {
  const { settings } = useSettings();
  useEffect(() => {
    const finalTitle = title || settings.seo.default_title;
    const desc = description || settings.seo.default_description;
    const img = imageUrl || mediaSrc(settings.seo.default_og_image_url) || "";
    const url = `${settings.seo.site_url || ""}${path}`;
    document.title = finalTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", finalTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    if (img) upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", img ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", finalTitle);
    upsertMeta("name", "twitter:description", desc);
    if (img) upsertMeta("name", "twitter:image", img);
  }, [title, description, path, imageUrl, type, settings]);
  return null;
}
